import {
    all,
    call,
    cancel,
    delay,
    fork,
    put,
    select,
    take,
    takeLatest,
} from "redux-saga/effects";
import { get, update } from "idb-keyval";
import { db, http } from "../../common/lib";
import actions from "../actions";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

const SUCCESS_STATUS = 200;

function* post() {
    try {
        const { app, auditLocations, audits } = yield select((state) => state);

        if (app.backgroundSyncEnabled) {
            const isGroupAudit =
                audits.item?.auditReference?.toLowerCase() !== "none";

            /** Get asset auditor  */
            let assetAuditorDB = (yield call(get, db.types.assetAuditor)) || [];
            let appSyncAssets = [];
            let auditAssetsDB = (yield call(get, db.types.auditAsset)) || [];

            /** If group audit get asset by group
             * else get audit by audit id
             */
            if (isGroupAudit) {
                assetAuditorDB = assetAuditorDB.filter(
                    (item) =>
                        item.auditAssignment.auditLocation.audit
                            ?.auditReference === audits.item.auditReference &&
                        !item?.assetSync
                );
                auditAssetsDB = auditAssetsDB.filter(
                    (item) =>
                        item.auditLocation.audit?.auditReference ===
                        audits.item.auditReference
                );
            } else {
                // /** Filter auditAssets  based on  Mandatory and Expected */
                // /** Removing  && item.isAssigned  for non mandatory assets */

                assetAuditorDB = assetAuditorDB.filter(
                    (item) =>
                        item.auditAssignment.auditLocation.audit.id ===
                        audits.item.id
                );

                auditAssetsDB = auditAssetsDB.filter(
                    (item) => item.auditLocation.audit.id === audits.item.id
                );
            }
            const getAssignedDate = (auditAssetId) => {
                return assetAuditorDB.find(
                    (item) => item.auditAsset.id === auditAssetId
                );
            };
            /** Structure for posting sync data */
            appSyncAssets = assetAuditorDB.map((item) => {
                /** assigned date from assetAuditorDB */
                const assignedDate = getAssignedDate(
                    item.auditAsset.id
                ).assignedDate;

                return {
                    assignedDate,
                    auditAsset: item.auditAsset.id,
                    auditLocation: item.auditAssignment.auditLocation.id,
                    assetStatus: item.status,
                    exclusionReason: item.exclusionReason,
                    exclusion_reason_date: item.exclusionReasonDate
                        ? item.exclusionReasonDate
                        : null,
                    auditor: item.auditAssignment.auditor,
                };
            });

            yield put(
                actions.app.create.update({ backgroundSyncRequest: true })
            );

            if (appSyncAssets.length > 0) {
                const res = yield call(
                    http.authorized.post,
                    config.api.paths.assetSync,
                    appSyncAssets
                );
                /** Update asset Auditor DB */
                if (res.status === SUCCESS_STATUS) {
                    yield call(
                        update,
                        db.types.assetAuditor,
                        (updatedAssetAuditorDB = []) => {
                            return updatedAssetAuditorDB.map((item) => {
                                if (!item?.assetSynced) {
                                    item.assetSynced = true;
                                }
                                return item;
                            });
                        }
                    );
                }

                // if there was no assets to sync with, we don't need to update our redux and db
                if (res.data.length === 0) {
                    //** Post sucess is required for syncing manually*/
                    yield all([
                        put(
                            actions.app.create.update({
                                backgroundSyncRequest: false,
                            })
                        ),
                        put(actionCreators.postSuccess()),
                    ]);
                    return null;
                }

                const assetIds = [...res.data];

                /** Update store  & audit asset DB */
                const updatedAssets = auditAssetsDB.map((item) => {
                    if (assetIds.includes(item.id)) {
                        item.isAssigned = true;
                    }
                    return item;
                });

                yield call(
                    update,
                    db.types.auditAsset,
                    (updatedAuditAssetDB = []) => {
                        return updatedAuditAssetDB.map((item) => {
                            if (assetIds.includes(item.id)) {
                                item.isAssigned = true;
                            }
                            return item;
                        });
                    }
                );
                yield put(
                    actions.auditAssets.create.writeRequest(updatedAssets)
                );
            }
            yield all([
                put(
                    actions.app.create.update({
                        backgroundSyncRequest: false,
                        assetSyncTime: new Date(),
                    })
                ),
                put(actionCreators.postSuccess()),
            ]);
        }
    } catch (error) {
        const errStr = error.toString();
        logToSentry("asset sync post", {
            error,
            errStr,
        });
        yield all([
            put(actions.app.create.update({ backgroundSyncRequest: false })),
            put(actionCreators.postFailure(error)),
        ]);
    }
}

function* watchTaskTick() {
    while (true) {
        yield delay(config.assetSync.timeout);
        const { app } = yield select((state) => state);
        // use asset-sync only if app is online
        if (app.netConnected) yield put(actionCreators.postRequest());
    }
}

function* watch() {
    // On Assets list loading initiate syncing request
    // TODO: requires proper mocking of indexDB
    //yield put(actionCreators.postRequest());

    //Sync assets on delay basis
    while (yield take(actionTypes.ASSET_SYNC_START)) {
        const workerTask = yield fork(watchTaskTick);
        yield take(actionTypes.ASSET_SYNC_STOP);
        yield cancel(workerTask);
    }
}
// For testing
export { post };
export default (function* () {
    yield all([takeLatest(actionTypes.ASSET_SYNC_POST_REQUEST, post), watch()]);
})();
